import { Lightbulb, Users, GraduationCap, Podcast } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      icon: <Lightbulb className="w-8 h-8" />,
      title: "AI-Based Learning",
      description: "Cutting-edge AI-powered educational tools and methodologies to enhance your learning experience."
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Consulting Services",
      description: "Expert consulting for businesses and individuals looking to leverage AI and technology."
    },
    {
      icon: <GraduationCap className="w-8 h-8" />,
      title: "Professional Certifications",
      description: "Industry-recognized certifications in AI, data science, and technology fields."
    },
    {
      icon: <Podcast className="w-8 h-8" />,
      title: "Educational Content",
      description: "Podcasts, videos, and materials covering math, science, and AI concepts."
    }
  ];

  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-base text-blue-900 font-semibold tracking-wide uppercase">Our Services</h2>
          <p className="mt-2 text-4xl lg:text-5xl font-bold text-gray-900">
            Comprehensive Learning Solutions
          </p>
          <p className="mt-4 text-lg text-gray-600">
            From training to consulting, we provide everything you need to succeed
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              data-testid={`service-card-${index}`}
              className="group bg-gradient-to-br from-blue-50 to-amber-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 border border-blue-100 hover:border-blue-300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-xl flex items-center justify-center text-amber-400 mb-6 group-hover:scale-110 transition-transform">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;